/* eslint-disable no-unreachable */
import React, { useState } from "react";
import axios from "axios";

const useProtalMainPage = ({
    onFinish = () => { }, //{ axiosMode, status, values }
    onBefore = () => { }, //{ axiosMode, status }
}) => {
    const mainApi = `/cramSchool/api/bill_payment_grade_class_student`
    const [billPaymentStatistic, setBillPaymentStatisticData] = useState([])
    const [perDayPayment, setPerDayPaymentData] = useState([])
    const [perClassPayment, setPerClassPaymentData] = useState([])
    const [perStudentPayment, setPerStudentPaymentData] = useState([])
    const getPerClassPayment = () => {
        return axios.get(`/cramSchool/api/chart/per_class_payment`, {

        })
            .then((response) => {

                let data = response.data?.data || []
                console.log({
                    data
                })
                setPerClassPaymentData(data)
            });
    }

    const getBillPaymentStatistic = ({

    }) => {
        return axios.get(`/cramSchool/api/chart/bill_payment_statistic`, {

        })
            .then((response) => {

                let data = response.data?.data || []
                console.log({
                    data
                })
                setBillPaymentStatisticData(data)
            });
    }

    const getPerDayPayment = ({

    }) => {
        return axios.get(`/cramSchool/api/chart/per_day_payment`, {

        })
            .then((response) => {

                let data = response.data?.data || []

                setPerDayPaymentData(data)
            });
    }
    const getPerStudentPayment = ({
    }) => {
        return axios.get(`/cramSchool/api/chart/per_student_payment`, {
        })
            .then((response) => {
                let data = response.data?.data || []
                setPerStudentPaymentData(data)
            });
    }
    return {
        billPaymentStatistic,
        getBillPaymentStatistic,
        perDayPayment,
        getPerDayPayment,
        perClassPayment,
        getPerClassPayment,
        perStudentPayment,
        getPerStudentPayment
    }

}
export { useProtalMainPage }